import product1 from "../assets/product1.png";
import product2 from "../assets/product2.png";
import product3 from "../assets/product3.png";
import product4 from "../assets/product4.png";
import product5 from "../assets/product5.png";
import product6 from "../assets/product6.png";
import product7 from "../assets/product7.png";
import product8 from "../assets/product8.png";
import product9 from "../assets/product9.png";
import product10 from "../assets/product10.png";
import gal1 from "../assets/gal1.png";
import gal2 from "../assets/gallerypud2.png";
import gal3 from "../assets/gal3.png";
import gal4 from "../assets/gallerypud4.jpeg";
import gal5 from "../assets/gallerypud5.png";
import gal6 from "../assets/gallerypud6.png";


export const GALLERY =[
  {image: gal1},
  {image: gal2},
  {image: gal3},
  {image: gal4},
  {image: gal5},
  {image: gal6},
]

export const PRODUCTS = [
  {
    id: 1,
    productName: "Signature Box",
    price: 25,
    productImage: product1,
    action: "Build your box",
    reviewStars: [5,0],
  },
  {
    id: 2,
    productName: "Set Pudding",
    price: 16,
    productImage: product2,
    action: "Build your set",
    reviewStars: [4,1],
  },
  {
    id: 3,
    productName: "Hoang Kim 2pcs",
    price: 5,
    productImage: product3,
    action: "add to cart",
    reviewStars: [4,0],
  },
  {
    id: 4,
    productName: "Kem Tuyet 2pcs",
    price: 6,
    productImage: product4,
    action: "add to cart",
    reviewStars: [5,0],
  },
  {
    id: 5,
    productName: "Durian 2pcs",
    price: 7,
    productImage: product5,
    action: "add to cart",
    reviewStars: [5,0],
  },
  {
    id: 6,
    productName: "Coconut Coffee Pudding",
    price: 3,
    productImage: product6,
    action: "add to cart",
    reviewStars: [5,0],
  },
  {
    id: 7,
    productName: "Custard Pudding",
    price: 3,
    productImage: product7,
    action: "add to cart",
    reviewStars: [4,1],
  },
  {
    id: 8,
    productName: "Durian crepe",
    price: 4,
    productImage: product8,
    action: "add to cart",
    reviewStars: [5,0],
  },
  {
    id: 9,
    productName: "Matcha mille crepe",
    price: 10,
    productImage: product9,
    action: "add to cart",
    reviewStars: [5,0],
  },
  {
    id: 9,
    productName: "Classic Tiramisu",
    price: 12,
    productImage: product10,
    action: "add to cart",
    reviewStars: [4,1],
  },
  
];
